export const PAGINATION = {
  SERVER: "server",
  CLIENT: "client",
};
